module.exports = __webpack_public_path__ + "media/images/faramia/facebook-4893644f999f5e31764415974e226a39.png";